import { createReducer } from '@reduxjs/toolkit';
import { apiRequestFailed, apiRequestSuccess } from 'services/api/api.actions';
import { setJumioCaller } from './jumio.actions';
import {
  postJumioDocStatusEndpoint,
  postJumioInfoEndpoint,
} from './jumio.config';
import {
  jumioEndFlowRedirect,
  jumioRedirectToErrorPage,
} from './jumio.helpers';
import {
  PostJumioDocStatusResponse,
  PostJumioInfoResponse,
} from './jumio.types';

const initialState = {
  jumioCaller: '',
  jumioInfo: {} as PostJumioInfoResponse,
  jumioDocStatus: {} as PostJumioDocStatusResponse,
};

const jumioReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(setJumioCaller, (state, action) => {
      state.jumioCaller = action.payload.caller;
    })
    .addCase(apiRequestSuccess, (state, action) => {
      const { payload } = action;
      const data = payload?.response?.data;

      if (payload.resourceId === postJumioInfoEndpoint) {
        state.jumioInfo = data;
      }

      if (payload.resourceId === postJumioDocStatusEndpoint) {
        state.jumioDocStatus = data;
        jumioEndFlowRedirect(state.jumioCaller);
      }
    })
    .addCase(apiRequestFailed, (state, action) => {
      const { payload } = action;

      if (payload.resourceId === postJumioInfoEndpoint) {
        jumioRedirectToErrorPage();
      }

      if (payload.resourceId === postJumioDocStatusEndpoint) {
        jumioEndFlowRedirect(state.jumioCaller);
      }
    }),
);

export default jumioReducer;
